import { getMeetingListFromAuthUserIdApi } from 'api/meeting';
import WatchingMeetingDataTable from 'app/components/DataTable/watching/WatchingMeetingDataTable';
import LoadingPopUp from 'app/components/LoadingPopup';
import React, { useEffect, useState } from 'react';

const WatchingMeetingPage = () => {

    const [loading, setLoading] = useState(false);
    const [meetingList, setMeetingList] = useState([]);
    const [total, setTotal] = useState(0);
    const [tableQuery, setTableQuery] = useState(null);

    useEffect(() => {
        const getAPI = async () => {
            if (!tableQuery) return;

            setLoading(true);
            try {
                // yetkili olduğu + üye/katılımcı olduğu toplantılar (sunucuda birleşir)
                const params = {
                    listMode: 'watching',
                    page: tableQuery.page,
                    limit: tableQuery.limit,
                    q: tableQuery.q,
                    sortBy: tableQuery.sortBy,
                    sortOrder: tableQuery.sortOrder,
                    ...tableQuery.filters,
                };
                const res = await getMeetingListFromAuthUserIdApi("management", params);
                setMeetingList(res.data || []);
                setTotal(res.total || 0);
            } catch (error) {
                console.error("API Hatası: ", error);
            } finally {
                setLoading(false);
            }
        };

        getAPI();
    }, [tableQuery]);

    const columnData = [
        { id: 'inst', align: 'center', disablePadding: false, label: "Kurum" },
        { id: 'unit', align: 'left', disablePadding: false, label: "Kurul/Kol/Komisyon" },
        { id: 'meetingNo', align: 'left', disablePadding: false, label: "Toplantı No" },
        { id: 'pdate', align: 'left', disablePadding: false, label: "Tarih" },
        { id: 'adminUserId', align: 'left', disablePadding: true, label: "Toplantı Yöneticisi" },
        { id: 'statFinish', align: 'left', disablePadding: true, label: "Durum" },
        { id: 'watch', align: 'center', disablePadding: true, label: "Toplantı İzle" },
    ];

    return (
        <React.Fragment>
            <>
                <LoadingPopUp open={loading} />
                <WatchingMeetingDataTable
                    mainData={meetingList}
                    total={total}
                    column={columnData}
                    pageTitle="Toplantı Listesi"
                    onQueryChange={setTableQuery}
                />
            </>
        </React.Fragment>
    );
};

export default WatchingMeetingPage;
